<style lang="less">
.discount-form {
  .el-select {
    width: 100%;
  }

  .el-form-item--medium {
    width: 100% !important;
  }

  .form-group-header {
    position: relative;
    margin-left: 30px;
    margin-bottom: 20px;
    color: #000;
  }
  .form-group-header::before {
    content: '';
    width: 3px;
    height: 18px;
    background-color: #409eff;
    position: absolute;
    top: 2px;
    left: -10px;
  }
  .discount-input {
    .el-select {
      width: 110px;
    }
  }
  .order-limit-input {
    .el-select {
      width: 110px;
    }
  }
}
</style>

<template>
  <el-card>
    <div slot="header">
      <h1 class="has-operation">
        <span>“{{activityName}}”折扣设置</span>
      </h1>
    </div>
    <div class="discount-form">
      <el-form v-loading="loading" ref="form" :model="form" :rules="rules" label-width="180px">
        <div class="form-group-header">基本信息</div>
        <el-form-item label="是否启用" prop="switch">
          <el-col :span="10">
            <el-switch v-model="form.switch"></el-switch>
          </el-col>
        </el-form-item>
        <el-form-item label="折扣名称" prop="title">
          <el-col :span="10">
            <el-input v-model="form.title" placeholder="请输入折扣名称"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="折扣描述" prop="desc">
          <el-col :span="10">
            <el-input type="textarea" v-model="form.desc" placeholder="请输入折扣描述"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="折扣内容" prop="content">
          <el-col :span="10">
            <el-input class="discount-input" v-model="form.content.value" :placeholder="currentDiscountTypeInfo ? currentDiscountTypeInfo.message : ''">
              <el-select v-model="form.content.type" placeholder="折扣类型" slot="prepend" @change="onChangeDiscountType">
                <el-option v-for="item in DISCOUNT_TYPES" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              <template slot="append">{{ currentDiscountTypeInfo ? currentDiscountTypeInfo.unit : '' }}</template>
            </el-input>
          </el-col>
        </el-form-item>
        <div class="form-group-header">促销范围及条件</div>
        <el-form-item label="类别范围" prop="cateIds">
          <el-col :span="10">
            <el-select v-model="form.cateIds" multiple placeholder="请选择分类">
              <el-option v-for="item in CATE_TREE" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="订单范围" prop="orderLimit">
          <el-col :span="10">
            <el-input class="order-limit-input" v-model="form.orderLimit.value" :placeholder="currentOrderLimitTypeInfo ? currentOrderLimitTypeInfo.message : ''">
              <el-select v-model="form.orderLimit.type" slot="prepend" placeholder="订单范围" @change="onChangeOrderLimitType">
                <el-option v-for="item in ORDER_LIMIT_TYPES" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              <template slot="append">{{ currentOrderLimitTypeInfo ? currentOrderLimitTypeInfo.unit : '' }}</template>
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item class="buttons">
          <el-col :span="10">
            <el-button type="primary" @click="submit">保存</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </div>
  </el-card>
</template>

<script>
import { restfulClient } from "@/api"
import { PROMOTION_TYPE_DISCOUNT, ORDER_LIMIT_TYPES, ORDER_LIMIT_TYPE_NUM, ORDER_LIMIT_TYPE_AMOUNT, DISCOUNT_TYPES, DISCOUNT_TYPE_RATE, DISCOUNT_TYPE_MINUS, RANGE_TYPE_INCLUDE } from "./enum"
import { unset } from 'lodash'

const DISCOUNT_API_PATH = 'activity-promotions'

const CATE_TREE = [
  {
    label: '手表',
    value: 4,
  },
  {
    label: '电子乐器',
    value: 6
  },
  {
    label: '电子教育',
    value: 7
  },
  {
    label: '计算器',
    value: 8
  },
  {
    label: '钟表',
    value: 198
  }
]

export default {
  data() {
    return {
      activityId: undefined,
      activityName: '',
      loading: false,
      form: {
        id: undefined,
        switch: true,
        title: '',
        desc: '',
        cateIds: [],
        orderLimit: {
          type: ORDER_LIMIT_TYPE_NUM,
          value: null
        },
        content: {
          type: DISCOUNT_TYPE_RATE,
          value: null
        }
      },
      rules: {
        title: [
          { required: true, message: '请输入折扣名称', trigger: ['blur', 'change'] }
        ],
        orderLimit: [
          {
            required: true,
            message: '请设置订单范围内容',
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!value.type) {
                callback('请选择订单范围类型')
                return
              }
              if (!value.value) {
                callback('请输入订单范围值')
                return
              }
              const numPatter = /^\d+$/;
              const amountPatter = /^\d+(\.\d{1,2})?$/;
              if (value.type == ORDER_LIMIT_TYPE_NUM && numPatter.test(value.value) !== true) {
                callback("请输入不小于1的整数" + value.value)
                return
              }
              if (value.type == ORDER_LIMIT_TYPE_AMOUNT && amountPatter.test(value.value) !== true) {
                callback("最多保留两位小数且大于0")
                return
              }
              callback()
            }
          }
        ],
        content: [
          {
            required: true,
            message: '请设置折扣内容',
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!value.type) {
                callback('请选择折扣类型')
                return
              }
              if (!value.value) {
                callback('请输入折扣值')
                return
              }
              const ratePatter = /^[0-9]+(\.[0-9]{1})?$/;
              const amountPatter = /^\d+(\.\d{1,2})?$/;
              if (value.type == DISCOUNT_TYPE_RATE && (ratePatter.test(value.value) !== true || Number(value.value) > 10)) {
                callback("最多保留一位小数且在0~10之间")
                return
              }
              if (value.type == DISCOUNT_TYPE_MINUS && (amountPatter.test(value.value) !== true || Number(value) > 9999)) {
                callback("最多保留两位小数且在0~9999之间")
                return
              }
              callback()
            }
          }
        ]
      },
      ORDER_LIMIT_TYPES,
      DISCOUNT_TYPES,
      CATE_TREE
    }
  },
  methods: {
    async loadDiscount() {
      const { collection } = await restfulClient.getCollection(DISCOUNT_API_PATH, {
        query: {
          activityId: this.activityId,
          type: PROMOTION_TYPE_DISCOUNT
        },
        limit: 1
      })
      if (collection.length > 0) {
        const discount = collection[0]
        this.form = {
          id: discount.id,
          switch: discount.switch,
          title: discount.title,
          desc: discount.desc,
          cateIds: discount.cateLimit && discount.cateLimit.value || [],
          orderLimit: discount.orderLimit || {},
          content: discount.content || {}
        }
      }
    },
    onChangeDiscountType() {
      this.form.content.value = null
    },
    onChangeOrderLimitType() {
      this.form.orderLimit.value = null
    },
    async submit() {
      await this.$formHelper.promisedValidate(this.$refs.form)
      let discount = {
        ...this.form,
        cateLimit: {
          type: RANGE_TYPE_INCLUDE,
          value: this.form.cateIds
        },
        activityId: this.activityId,
        type: PROMOTION_TYPE_DISCOUNT
      }
      const id = this.form.id
      unset(discount, 'id')
      unset(discount, 'cateIds')
      this.loading = true
      try {
        id ? await restfulClient.update(DISCOUNT_API_PATH, id, discount)
          : await restfulClient.create(DISCOUNT_API_PATH, discount)
      } finally {
        this.loading = false
      }
      this.$message.success('折扣设置保存成功')
      this.$router.push({ name: 'activity-activity' })
    }
  },
  computed: {
    currentDiscountTypeInfo() {
      return this.DISCOUNT_TYPES.find(item => item.value === this.form.content.type)
    },
    currentOrderLimitTypeInfo() {
      return this.ORDER_LIMIT_TYPES.find(item => item.value === this.form.orderLimit.type)
    }
  },
  async mounted() {
    const { id, activityName } = this.$route.params
    if (!id) return this.$router.push('/activity/activity')
    this.activityId = id
    this.activityName = activityName

    this.loadDiscount()
  }
}
</script>

